import { render, staticRenderFns } from "./activeLoanComponent.vue?vue&type=template&id=009fafac&"
import script from "./activeLoanComponent.vue?vue&type=script&lang=js&"
export * from "./activeLoanComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports